// Скачивание файлов из SPA: presigned-ссылки живут на другом origin
// (s3.<domain>), где атрибут download игнорируется браузером — поэтому байты
// забираются fetch'ем и отдаются как blob с нашим именем файла.

export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.rel = 'noopener'
  a.click()
  // Отложенный revoke: немедленный обрывает начатое скачивание в Firefox.
  setTimeout(() => URL.revokeObjectURL(url), 30_000)
}

export async function downloadFromUrl(url: string, filename: string): Promise<void> {
  const res = await fetch(url)
  if (!res.ok) throw new Error(`download: HTTP ${res.status}`)
  saveBlob(await res.blob(), filename)
}

// Имя файла из последнего сегмента пути URL (без query); fallback при неудаче.
export function filenameFromUrl(url: string, fallback: string): string {
  try {
    const last = new URL(url).pathname.split('/').filter(Boolean).pop()
    return last ? decodeURIComponent(last) : fallback
  } catch {
    return fallback
  }
}
